import { Dropdown } from 'primereact/dropdown';
import { Source, User } from 'Interfaces/BDPortalInterfaces';
import styles from './PortfolioOpportuntiesListScreen.module.scss';
import EditOpportunity from '../EditOpportunity/EditOpportunity';
import { Skeleton } from 'primereact/skeleton';
import { observer } from 'mobx-react';
import { ProgressSpinner } from 'primereact/progressspinner';
import OpportunityFilter from '../OpportunityFilter/OpportunityFilter';
import PortfolioOpportuntiesListScreenLogic from './PortfolioOpportuntiesListScreen.logic';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { bdTrackerAllowedRoles } from 'data/bdTracker/bdTrackerUserRoleValidations';
import { Avatar } from 'primereact/avatar';
import { getInitials } from 'utils/getInitials';
import { getBackgroundColor } from 'utils/avatarUtilities';
import { colorCodingData } from 'data/bdTracker/IterationsColorCodingData';
import { formatDateToDateTimeString } from 'utils/dateUtilities';
import { getStatus } from 'utils/bdTrackerUtilities/checkStageUtility';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';

const PortfolioOpportunitiesListScreen: React.FC = () => {
  const {
    userModulesRoles,
    isDropDownDetailsAndOppLoading,
    boardDetails,
    handleSetItertation,
    iteration,
    opportunityIID,
    isEditOpportunityModalOpen,
    closeEditOpportunityModal,
    handleListButtonClick,
    board,
    filterAnalyst: _filterAnalyst,
    portfolioOpportunityDetails,
    searchKeyword: _searchKeyword,
    handleCardClick,
    filterStatus: _filterStatus,
    filterStage: _filterStage,
    quickLoadCards,
    handleDropdownChange,
    opportunityID,
    handleAccordionClick,
    expandedPortfolioStages,
    getSourceNameForSourceId,
    filterOpportunityIterationsForTheappliedFilters,
    handleClickSelectAllForPortfolioCounter,
    handleClickSelectSingleIteration,
    handleCheckIfAllPendingOpportunitiesAreSelected,
    checkIfParticularIterationIsSelected,
    checkIfSelectAllIsDisabled,
    checkIfAnyIterationSelected,
    handleUpdatePortfolioTabStatus,
    handleUpdatePortfolioTabStage,
    getPortfolioTabStage,
    getPortfolioTabStatus,
    handleSaveButtonClick,
    checkIfPortfolioTableUpdating,
    checkIfPortfolioSaveButtonIsDisabled,
  } = PortfolioOpportuntiesListScreenLogic();

  const assigneeOptionTemplate = (option: User | null) => {
    return (
      <>
        {option ? (
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <div style={{ width: '3rem', height: '100%' }}>
              <Avatar
                title={option.Name}
                id="profileAvatar"
                shape="circle"
                label={option.Name && getInitials(option?.Name)}
                style={{
                  backgroundColor: getBackgroundColor(option.Name[0]),
                  color: '#522D6E',
                  marginRight: '0.5rem',
                }}
              />
            </div>
            <div>{option.Name}</div>
          </div>
        ) : (
          <span>Unassigned</span>
        )}
      </>
    );
  };
  return (
    <>
      <OpportunityFilter
        boardType={iteration}
        setBoardType={handleSetItertation}
        viewType={'PortfolioOpportunities'}
        handleListClick={handleListButtonClick}
        isPortfolioFilterVisible={false}
      />
      {!isDropDownDetailsAndOppLoading ? (
        <div className={styles.listView} style={{ padding: '0 1rem' }}>
          <div className={styles.listViewHeader}>
            <h4>-</h4>
            <h4>OID</h4>
            <h4>MOLECULE NAME</h4>
            <h4>SOURCE</h4>
            <h4>STAGE</h4>
            <h4>STATUS</h4>
            <h4>ANALYSTS</h4>
          </div>
          {(board === 'NC' || board === 'MAS') && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.6rem',
              }}
              className="portfolioOpportunitiesViewListScreen"
            >
              {portfolioOpportunityDetails.map((opportunities, index) => {
                return filterOpportunityIterationsForTheappliedFilters(opportunities.opportunities)
                  .length > 0 ? (
                  <>
                    <div key={index} className="bdportal">
                      {/* Stage Header */}
                      <button
                        onClick={() => handleAccordionClick(opportunities.PortfolioCounter)}
                        className={`bdportal w-full text-left ${!checkIfAnyIterationSelected(opportunities.PortfolioCounter) ? 'p-4' : 'px-4 py-2'} rounded flex items-center gap-2 relative`}
                        style={
                          expandedPortfolioStages.has(opportunities.PortfolioCounter)
                            ? {
                                background: 'var(--bg-navbar)',
                                color: 'white',
                              }
                            : {
                                backgroundColor: 'var(--bg-plan-div)',
                                color: 'var(--text-primary)',
                                border: '1px solid var(--border-primary)',
                              }
                        }
                      >
                        <span
                          style={{
                            backgroundColor:
                              colorCodingData[Number(opportunities.PortfolioCounter % 50) || 20],
                            position: 'absolute',
                            width: '0.3rem',
                            top: 0,
                            bottom: 0,
                            left: 0,
                          }}
                        ></span>
                        <Checkbox
                          disabled={checkIfSelectAllIsDisabled(opportunities.PortfolioCounter)}
                          onClick={e => {
                            e.stopPropagation();
                            handleClickSelectAllForPortfolioCounter(opportunities.PortfolioCounter);
                          }}
                          // className={classes.rowSelectCheckBox}
                          checked={
                            !checkIfSelectAllIsDisabled(opportunities.PortfolioCounter) &&
                            handleCheckIfAllPendingOpportunitiesAreSelected(
                              opportunities.PortfolioCounter
                            )
                          }
                          style={{
                            border: '1px solid var(--border-primary)',
                            borderRadius: "0.5rem"
                          }}
                        />
                        <span
                          style={
                            expandedPortfolioStages.has(opportunities.PortfolioCounter)
                              ? {
                                  rotate: '90deg',
                                  marginLeft: '0.5rem',
                                  transitionDuration: '0.5s',
                                }
                              : {
                                  display: 'flex',
                                  marginLeft: '0.5rem',
                                  transitionDuration: '0.5s',
                                }
                          }
                        >
                          ►
                        </span>
                        <span>
                          {opportunities.opportunities.length > 0
                            ? getSourceNameForSourceId(opportunities.opportunities[0].SourceID)
                            : ''}{' '}
                          -{' '}
                          {opportunities.opportunities.length > 0
                            ? opportunities.opportunities[0].PrimarySupplierID
                            : ''}
                        </span>
                        {!checkIfAnyIterationSelected(opportunities.PortfolioCounter) ? (
                          <span style={{ marginLeft: 'auto' }}>
                            Created At -{' '}
                            {opportunities.opportunities.length > 0
                              ? formatDateToDateTimeString(
                                  opportunities.opportunities[0].LastModifiedDate
                                )
                              : ''}
                          </span>
                        ) : (
                          <div
                            style={{
                              marginLeft: 'auto',
                              display: 'flex',
                              gap: '1rem',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <div
                              className={styles.dropdown}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '0.5rem',
                                width: '12.9vw',
                              }}
                            >
                              <Dropdown
                                options={boardDetails?.[board]?.Stage}
                                optionLabel="Stage"
                                optionValue="ID"
                                value={getPortfolioTabStage(opportunities.PortfolioCounter)}
                                onChange={e =>
                                  handleUpdatePortfolioTabStage(
                                    opportunities.PortfolioCounter,
                                    e.value
                                  )
                                }
                                onClick={e => e.stopPropagation()}
                                placeholder="Unassigned"
                                className={styles.selectDropdown}
                                disabled={
                                  !checkIfFunctionalityEnabled(
                                    bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                                    userModulesRoles.opptracker,
                                    userModulesRoles
                                  )
                                }
                                style={{ width: '100%' }}
                              />
                            </div>
                            <div
                              className={styles.dropdown}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '0.5rem',
                                width: '12.9vw',
                              }}
                            >
                              {(() => {
                                const portfolioStageID = getPortfolioTabStage(
                                  opportunities.PortfolioCounter
                                );
                                const portfolioStatusID = getPortfolioTabStatus(
                                  opportunities.PortfolioCounter
                                );

                                return (
                                  <Dropdown
                                    options={getStatus(
                                      portfolioStageID || 0,
                                      boardDetails?.[board]?.Status || []
                                    )}
                                    optionLabel="Status"
                                    optionValue="ID"
                                    onClick={e => e.stopPropagation()}
                                    value={portfolioStatusID}
                                    onChange={e =>
                                      handleUpdatePortfolioTabStatus(
                                        opportunities.PortfolioCounter,
                                        e.value
                                      )
                                    }
                                    placeholder="Unassigned"
                                    className={styles.selectDropdown}
                                    style={{
                                      width: '100%',
                                      backgroundColor:
                                        (portfolioStatusID === 1 && portfolioStageID !== 8) ||
                                        (portfolioStageID === 8 && portfolioStatusID === 5)
                                          ? '#ffcccc'
                                          : portfolioStatusID === 2 ||
                                              (portfolioStageID === 8 && portfolioStatusID === 1)
                                            ? '#fff4cc'
                                            : portfolioStatusID === 3 || portfolioStatusID === 4
                                              ? '#d4f8cc'
                                              : 'white',
                                      border:
                                        (portfolioStatusID === 1 && portfolioStageID !== 8) ||
                                        (portfolioStageID === 8 && portfolioStatusID === 5)
                                          ? '1px solid #a80000'
                                          : portfolioStatusID === 2 ||
                                              (portfolioStageID === 8 && portfolioStatusID === 1)
                                            ? '1px solid #b38b00'
                                            : portfolioStatusID === 3 || portfolioStatusID === 4
                                              ? '1px solid #006400'
                                              : '1px solid transparent',
                                    }}
                                    pt={{
                                      input: {
                                        style: {
                                          color:
                                            (portfolioStatusID === 1 && portfolioStageID !== 8) ||
                                            (portfolioStageID === 8 && portfolioStatusID === 5)
                                              ? '#a80000'
                                              : portfolioStatusID === 2 ||
                                                  (portfolioStageID === 8 &&
                                                    portfolioStatusID === 1)
                                                ? '#b38b00'
                                                : portfolioStatusID === 3 || portfolioStatusID === 4
                                                  ? '#006400'
                                                  : 'black',
                                        },
                                      },
                                      trigger: {
                                        style: {
                                          color:
                                            (portfolioStatusID === 1 && portfolioStageID !== 8) ||
                                            (portfolioStageID === 8 && portfolioStatusID === 5)
                                              ? '#a80000'
                                              : portfolioStatusID === 2 ||
                                                  (portfolioStageID === 8 &&
                                                    portfolioStatusID === 1)
                                                ? '#b38b00'
                                                : portfolioStatusID === 3 || portfolioStatusID === 4
                                                  ? '#006400'
                                                  : 'black',
                                        },
                                      },
                                    }}
                                    disabled={
                                      !checkIfFunctionalityEnabled(
                                        bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                                        userModulesRoles.opptracker,
                                        userModulesRoles
                                      )
                                    }
                                  />
                                );
                              })()}
                            </div>
                            <Button
                              className={styles.saveButton}
                              style={{
                                backgroundColor: '#6969ff',
                                color: 'white',
                                height: '2.7rem',
                                width: '12.4vw',
                                padding: '0.5rem 1rem',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                              onClick={e => {
                                e.stopPropagation();
                                handleSaveButtonClick(opportunities.PortfolioCounter);
                              }}
                              loading={checkIfPortfolioTableUpdating(
                                opportunities.PortfolioCounter
                              )}
                              disabled={checkIfPortfolioSaveButtonIsDisabled(
                                opportunities.PortfolioCounter
                              )}
                            >
                              <span>Update</span>
                            </Button>
                          </div>
                        )}
                      </button>
                      {/* {expandedPortfolioStages.has(
                      opportunities.PortfolioCounter
                    ) && ( */}
                      <div
                        style={
                          expandedPortfolioStages.has(opportunities.PortfolioCounter)
                            ? {
                                // maxHeight: '400px',
                                height: `${
                                  3.8 *
                                  filterOpportunityIterationsForTheappliedFilters(
                                    opportunities.opportunities
                                  ).length
                                }rem`,
                                transitionDuration: '0.3s',
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden',
                                paddingBottom: '0.2rem',
                              }
                            : {
                                height: 0,
                                overflow: 'hidden',
                                transitionDuration: '0.3s',
                              }
                        }
                        className={styles.portfolioOpportunitiesInstance}
                      >
                        {filterOpportunityIterationsForTheappliedFilters(
                          opportunities.opportunities
                        ).map(opportunity => {
                          const source = boardDetails?.[board]?.Source?.find(
                            (src: Source) => src.ID === opportunity.SourceID
                          )?.Source;
                          // const isLoadingCard = quickLoadCards.has(opportunity.OpportunityIterationsID);
                          return (
                            <div
                              key={opportunity.OpportunityIterationsID}
                              className={styles.listCard}
                              style={{
                                width: '100%',
                                position: 'relative',
                              }}
                            >
                              {quickLoadCards.has(opportunity.OpportunityIterationsID) && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: '#ffffff80',
                                    zIndex: 10,
                                  }}
                                >
                                  <ProgressSpinner
                                    style={{
                                      width: '30px',
                                      height: '30px',
                                    }}
                                    strokeWidth="8"
                                    fill="var(--surface-ground)"
                                    animationDuration=".5s"
                                  />
                                </div>
                              )}
                              <span>
                                <Checkbox
                                  // disabled={isBulkUpdating}
                                  onClick={() =>
                                    handleClickSelectSingleIteration(
                                      opportunity.OpportunityIterationsID
                                    )
                                  }
                                  // className={classes.rowSelectCheckBox}
                                  checked={checkIfParticularIterationIsSelected(
                                    opportunity.OpportunityIterationsID
                                  )}
                                  style={{
                                    border: '1px solid var(--border-primary)',
                                    borderRadius: "0.5rem"
                                  }}
                                />
                              </span>
                              <span>
                                {opportunity.IterationCounter ? opportunity.IterationCounter : '-'}
                              </span>
                              <span
                                className={styles.moleculeField}
                                onMouseOver={e =>
                                  (e.currentTarget.style.textDecoration = 'underline')
                                }
                                onMouseOut={e => (e.currentTarget.style.textDecoration = 'none')}
                                onClick={() => {
                                  handleCardClick(
                                    opportunity.OpportunityIterationsID,
                                    opportunity.OpportunityID
                                  );
                                }}
                              >
                                {opportunity.MoleculeAndForm}
                              </span>
                              <div>{source}</div>
                              <div className={styles.dropdown}>
                                <Dropdown
                                  options={boardDetails?.[board]?.Stage}
                                  optionLabel="Stage"
                                  optionValue="ID"
                                  value={opportunity.StageID}
                                  onChange={e =>
                                    handleDropdownChange(
                                      index,
                                      opportunity.OpportunityIterationsID,
                                      'Stage',
                                      e.value
                                    )
                                  }
                                  placeholder="Select Stage"
                                  className={styles.selectDropdown}
                                  disabled={
                                    !checkIfFunctionalityEnabled(
                                      bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                                      userModulesRoles.opptracker,
                                      userModulesRoles
                                    )
                                  }
                                />
                              </div>
                              <div className={styles.dropdown}>
                                <Dropdown
                                  options={getStatus(
                                    opportunity.StageID,
                                    boardDetails?.[board]?.Status || []
                                  )}
                                  optionLabel="Status"
                                  optionValue="ID"
                                  value={opportunity.StatusID}
                                  onChange={e =>
                                    handleDropdownChange(
                                      index,
                                      opportunity.OpportunityIterationsID,
                                      'Status',
                                      e.value
                                    )
                                  }
                                  placeholder="Select Status"
                                  className={styles.selectDropdown}
                                  style={{
                                    width: '9rem',
                                    backgroundColor:
                                      (opportunity.StatusID === 1 && opportunity.StageID !== 8) ||
                                      (opportunity.StageID === 8 && opportunity.StatusID === 5)
                                        ? '#ffcccc'
                                        : opportunity.StatusID === 2 ||
                                            (opportunity.StageID === 8 &&
                                              opportunity.StatusID === 1)
                                          ? '#fff4cc'
                                          : opportunity.StatusID === 3 || opportunity.StatusID === 4
                                            ? '#d4f8cc'
                                            : 'white',
                                    border:
                                      (opportunity.StatusID === 1 && opportunity.StageID !== 8) ||
                                      (opportunity.StageID === 8 && opportunity.StatusID === 5)
                                        ? '1px solid #a80000'
                                        : opportunity.StatusID === 2 ||
                                            (opportunity.StageID === 8 &&
                                              opportunity.StatusID === 1)
                                          ? '1px solid #b38b00'
                                          : opportunity.StatusID === 3 || opportunity.StatusID === 4
                                            ? '1px solid #006400'
                                            : '1px solid transparent',
                                  }}
                                  pt={{
                                    input: {
                                      style: {
                                        color:
                                          (opportunity.StatusID === 1 &&
                                            opportunity.StageID !== 8) ||
                                          (opportunity.StageID === 8 && opportunity.StatusID === 5)
                                            ? '#a80000'
                                            : opportunity.StatusID === 2 ||
                                                (opportunity.StageID === 8 &&
                                                  opportunity.StatusID === 1)
                                              ? '#b38b00'
                                              : opportunity.StatusID === 3 ||
                                                  opportunity.StatusID === 4
                                                ? '#006400'
                                                : 'black',
                                      },
                                    },
                                    trigger: {
                                      style: {
                                        color:
                                          (opportunity.StatusID === 1 &&
                                            opportunity.StageID !== 8) ||
                                          (opportunity.StageID === 8 && opportunity.StatusID === 5)
                                            ? '#a80000'
                                            : opportunity.StatusID === 2 ||
                                                (opportunity.StageID === 8 &&
                                                  opportunity.StatusID === 1)
                                              ? '#b38b00'
                                              : opportunity.StatusID === 3 ||
                                                  opportunity.StatusID === 4
                                                ? '#006400'
                                                : 'black',
                                      },
                                    },
                                  }}
                                  disabled={
                                    !checkIfFunctionalityEnabled(
                                      bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                                      userModulesRoles.opptracker,
                                      userModulesRoles
                                    )
                                  }
                                />
                              </div>
                              <div className={styles.dropdown}>
                                <Dropdown
                                  options={boardDetails?.[board]?.User}
                                  optionLabel="Name"
                                  optionValue="ID"
                                  value={opportunity.AnalystID}
                                  onChange={e =>
                                    handleDropdownChange(
                                      index,
                                      opportunity.OpportunityIterationsID,
                                      'Analyst',
                                      e.value
                                    )
                                  }
                                  placeholder="Unassigned"
                                  className={styles.selectDropdown}
                                  disabled={
                                    !checkIfFunctionalityEnabled(
                                      bdTrackerAllowedRoles.listViewStageStatusAnalyst,
                                      userModulesRoles.opptracker,
                                      userModulesRoles
                                    )
                                  }
                                  itemTemplate={assigneeOptionTemplate}
                                  valueTemplate={assigneeOptionTemplate}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {/* )} */}
                    </div>
                  </>
                ) : (
                  <></>
                );
              })}
            </div>
          )}
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            padding: '1rem 1rem',
          }}
        >
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
          <Skeleton height="3rem" width="100%"></Skeleton>
        </div>
      )}
      {isEditOpportunityModalOpen && opportunityIID && opportunityID !== null && (
        <EditOpportunity
          visible={isEditOpportunityModalOpen}
          closeModal={closeEditOpportunityModal}
          viewType={'List'}
          opportunityIterationID={opportunityIID}
          opportunityID={opportunityID}
        />
      )}
    </>
  );
};

export default observer(PortfolioOpportunitiesListScreen);
